import { Icons } from '@agro-club/agroclub-shared'
import { DASH } from 'modules/constants'
import { FC, useState } from 'react'
import styled from 'styled-components'
import { AButton } from 'views/components/Analytics'
import { EditLogisticianModal } from './EditLogisticianModal/EditLogisticianModal'

interface Props {
  data: any
  permissions: string[]
  deal_id: string
  onSuccess: () => void
}

const LogisticianWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 4px;
`

const LogisticianList = styled.div`
  display: flex;
  flex-direction: column;
`

export const LogisticianCell: FC<Props> = ({ data, permissions, deal_id, onSuccess }) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const logisticianIds = data.logisticians?.filter(Boolean).map((el) => el.id)

  return (
    <>
      <LogisticianWrapper>
        <LogisticianList>
          {!!data.logisticians?.length
            ? data.logisticians.map((el, index) => <div key={el?.id || index}>{el?.full_name || DASH}</div>)
            : DASH}
        </LogisticianList>

        <AButton
          id="edit"
          color="secondary"
          Icon={Icons.IconEdit}
          size="small"
          onClick={() => setIsModalOpen(true)}
          disabled={!permissions.includes('deals.change_dealexecutors')}
        />
      </LogisticianWrapper>

      {isModalOpen && (
        <EditLogisticianModal
          ids={logisticianIds}
          deal_id={deal_id}
          onClose={() => setIsModalOpen(false)}
          onSuccess={onSuccess}
        />
      )}
    </>
  )
}
